<template>
  <div class="image-uploader">
    <div v-if="!imageUrl" class="upload-placeholder" @click="triggerFileInput">
      <SfIcon icon="plus" size="1.25rem" />
      <span>
        <template v-if="accept.indexOf('image')!==-1">
          {{ $t('uploadImage') }}
        </template>
        <template v-else>
          {{ $t('uploadVideo') }}
        </template>
      </span>
    </div>
    <div v-else class="image-preview">
      <img v-if="accept.indexOf('image')!==-1" :src="imageUrl" alt="Uploaded image" />
      <video v-if="accept.indexOf('video')!==-1" :id="'goodsfGalleryBig'" :autoplay="true" muted preload="load" loop
        ref="sfGalleryBigImage" :src="imageUrl" :width="'100%'"
        :height="'auto' || '100%'" style="object-position: top;max-height:620px;"
        :class="{ 'sf-gallery__big-image': true, 'sf-gallery__big-image--has-zoom': true }"
        controls="controls" playsinline>
        <source :src="imageUrl" :type="'video/' + houzhui">
      </video>
      <button class="remove-button" @click="removeImage">
        <!-- <XIcon class="x-icon" /> -->
        <SfIcon icon="cross" size="1.25rem" />
      </button>
    </div>
    <input
      type="file"
      ref="fileInput"
      @change="onFileSelected"
      :accept="accept"
      style="display: none;"
    />
    <confirmModal ref="uploadProgressRef"
      class="uploadProgressModal"
      :showFooter="false" :isClose="false">
      <div slot="context">
        <div v-if="uploadProgress >= 0 || uploadProgress <= 100" class="progress-bar">
          <div class="progress" :style="{ width: `${uploadProgress}%` }"></div>
          <div style="text-align: center;"> {{ uploadProgress }}% </div>
        </div>
      </div>
    </confirmModal>
  </div>
</template>

<script>
import { ref, onMounted } from '@nuxtjs/composition-api';
import { SfIcon } from '@storefront-ui/vue';
import axios from 'axios';
import confirmModal from '~/components/ContentModal/confirm';
import { randomUUID } from '@/plugins/utils';
import { useApiError } from '@bee-hole/coms';
export default {
  components: {
    SfIcon,
    confirmModal
  },
  props: {
    type: {
      type: String,
      default: 'image'
    }
  },
  setup(props, context) {
    const { emit, root } = context;
    console.log('props', context);
    const accept = ref('image/*');
    if (props.type === 'video') {
      accept.value = 'video/*';
    }
    //
    const { set: setError } = useApiError();
    //
    const houzhui = ref('');
    const fileInput = ref(null);
    const imageUrl = ref(null);
    const uploadProgress = ref(0);
    const uploadProgressRef = ref(null);
    const triggerFileInput = () => {
      fileInput.value.click();
    };
    // const seriCookie = (cookieObject) => {
    //   const cookieStrings = [];
    //   for (const key in cookieObject) {
    //     const serializedCookie = cookie.serialize(key, cookieObject[key]);
    //     cookieStrings.push(serializedCookie);
    //   }
    //   return cookieStrings.join("; ");
    // };
    const getHouzhui = (url) => {
      try {
        const houzhui1 = url?.split('.').pop()?.toLowerCase();
        houzhui.value = houzhui1;
      } catch (e) {
        console.log('houzhuiErr===========', e);
      }
    };
    const uploadFile = async (file) => {
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   imageUrl.value = e.target.result;
      // };
      // reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append('file', file);
      formData.append('tmp_id', randomUUID());
      const cookiesData = root.$cookies.getAll();
      formData.append('domain', cookiesData.domain);
      // const cookieVal = seriCookie(cookiesData);
      try {
        uploadProgressRef.value.setModal({
          title: root.$t('uploadImageing')
        });
        // 模拟上传进度
        const interval = setInterval(() => {
          uploadProgress.value += 10;
          if (uploadProgress.value >= 100) {
            clearInterval(interval);
          }
        }, 1000);
        const response = await axios.post(root.$options?.$config?.API_URL_WEB + '/mall/upload/file', formData, {
          headers: {
            // 'Content-Type': 'application/json',
            // 'accept': '*/*',
            // 'Access-Control-Allow-Origin': process.env.API_URL,
            // 'Access-Control-Allow-Credentials': true,
            'Content-Type': 'multipart/form-data',
            // 'withCredentials': true,
            // 'Content-Type': 'application/x-www-form-urlencoded',
            // 'Cookie': cookieVal
            'authorization': 'Bearer ' + cookiesData.token
          }
          // onUploadProgress: (progressEvent) => {
          //   // const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          //   // console.log('progressEvent', progressEvent.loaded, progressEvent.total, percentCompleted);
          //   // uploadProgress.value = percentCompleted;
          // }
        });
        if (response.status === 200) {
          const result = response.data;
          if (result.code === 0) {
            console.log('result', result);
            const uploadedUrl = result.data.file_path;
            imageUrl.value = uploadedUrl;
            uploadProgressRef.value.close();
            console.log('后缀');
            getHouzhui(uploadedUrl);
            console.log('回调', uploadedUrl);
            emit('uploadOk', uploadedUrl);
          } else {
            uploadProgress.value = 0;
            clearInterval(interval);
            uploadProgressRef.value.close();
            setError({ message: result.message, code: 50 });
            throw new Error('Upload failed');
          }
        } else {
          uploadProgress.value = 0;
          clearInterval(interval);
          uploadProgressRef.value.close();
          setError({ message: response.data.message, code: 50 });
          throw new Error('Upload failed');
        }
      } catch (error) {
        emit('upload-error', error.message);
      } finally {
        uploadProgressRef.value.close();
        uploadProgress.value = 0;
      }
    };
    const onFileSelected = (event) => {
      const file = event.target.files[0];
      if (file) {
        uploadFile(file);
      }
    };

    const removeImage = () => {
      imageUrl.value = null;
      if (fileInput.value) {
        fileInput.value.value = '';
      }
      emit('image-removed');
    };
    onMounted(() => {
      // uploadProgressRef.value.setModal({
      //   title: root.$t('uploadImageing')
      // });
    });
    return {
      fileInput,
      imageUrl,
      uploadProgress,
      triggerFileInput,
      onFileSelected,
      removeImage,
      uploadProgressRef,
      accept,
      houzhui
    };
  }
};
</script>

<style scoped>
.image-uploader {
  width: 100px;
  height: 100px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666;
}

.plus-icon, .x-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 8px;
}

.image-preview {
  width: 100%;
  height: 100%;
  position: relative;
}

.image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-button {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
}

.progress-bar {
  /* position: absolute; */
  /* bottom: 0; */
  /* left: 0; */
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
}

.progress {
  height: 100%;
  background-color: #4caf50;
  transition: width 0.2s ease-in-out;
}
</style>

<style lang="scss">
.uploadProgressModal{
  @include for-mobile{
    .sf-modal__overlay.sf-overlay{
      left: -10vw;
    }
    .sf-modal__container{
      --modal-transform: translate3d(0%, 0%, 0);
      left: 0;
    }
  }
}
</style>
